import { Link } from "react-router-dom";

// Locally hosted, pre-trimmed & transparent-background version of the brand logo.
const LOGO_URL = "/avvanta-logo.png";

export const Logo = ({ variant = "dark", className = "" }) => {
  const isLight = variant === "light";
  return (
    <Link
      to="/"
      data-testid="site-logo"
      className={`inline-flex items-center select-none group ${className}`}
      aria-label="Avvanta Advisory — Home"
    >
      <span
        className={`inline-flex items-center justify-center transition-colors duration-300 ${
          isLight
            ? "bg-white rounded-sm px-4 py-2.5 shadow-[0_8px_24px_-12px_rgba(0,0,0,0.4)]"
            : ""
        }`}
      >
        <img
          src={LOGO_URL}
          alt="Avvanta Advisory"
          className={`${
            isLight ? "h-9 md:h-10" : "h-11 md:h-[52px]"
          } w-auto object-contain transition-transform duration-500 group-hover:scale-[1.03]`}
          draggable="false"
        />
      </span>
    </Link>
  );
};

export default Logo;
